export default __webpack_public_path__ + "static/media/game2.d4a6fa3b.png";